var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'InvoiceLogList'
      }
    }
  }, [_vm._v(" 登錄發票列表 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("發票審核")])], 1)], 1)])]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("發票審核")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, [_c('InvoiceLogForm', {
    ref: "invoiceLogForm",
    attrs: {
      "invoice-log": _vm.invoiceLog,
      "form-readonly": true
    }
  })], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center mt-3"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goList
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("儲存")])], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }